import { Button, Card } from '@ths/ui';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { notifyHotelSavedCardsChanged } from '../hotel/savedCardReturn';

export default function SavedCardReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    notifyHotelSavedCardsChanged();
  }, []);
  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4 text-text">
      <Card className="w-full max-w-lg space-y-4 p-6">
        <h1 className="text-xl font-medium">
          {params.get('status') === 'cancelled'
            ? 'Card setup cancelled'
            : 'Return to THS'}
        </h1>
        <p>
          You can close this tab and continue in your original THS tab, or
          return to THS.
        </p>
        <Button onClick={() => navigate('/select-client')}>
          Return to THS
        </Button>
      </Card>
    </main>
  );
}
